

export function DrawSVGWedge(path: SVGPathElement, radius: number, center: { x: number, y: number }, bearing: number, angle: number) {

  const radians = Math.PI / 180;
  const isNegative = angle < 0;
  if (angle < 0) {
    angle = Math.abs(angle);
    bearing -= angle;
  }
  const startAngle = (bearing - 90) // Start angle with 0 degrees at the top
  const direction = angle >= 0 ? 1 : 0;
  const startPointX = center.x + radius * Math.cos(startAngle * radians);
  const startPointY = center.y + radius * Math.sin(startAngle * radians);

  const endPointX = center.x + radius * Math.cos((startAngle + angle) * radians);
  const endPointY = center.y + radius * Math.sin((startAngle + angle) * radians);

  const largeArcFlag = angle <= 180 ? 0 : 1; // Set largeArcFlag based on the angle

  // Update the path attribute
  const pathData = `M ${center.x},${center.y} L ${startPointX},${startPointY} A ${radius},${radius} 0 ${largeArcFlag},${direction} ${endPointX},${endPointY} Z`;
  path.setAttribute('d', pathData);
  if ((angle >= 360) || (angle <= -360)) {
    DrawSVGCircle(path, center, radius);
  }
  if (isNegative) {
    return { center: center, start: { x: endPointX, y: endPointY }, radius: radius, end: { x: startPointX, y: startPointY } }
  } else {
    return { center: center, start: { x: startPointX, y: startPointY }, radius: radius, end: { x: endPointX, y: endPointY } }

  }

}

export function DrawSVGCircle(path: SVGPathElement, center: { x: number, y: number }, radius: number) {
  const pathData = `M ${center.x - radius},${center.y} A ${radius},${radius} 0 1,0 ${center.x + radius},${center.y} A ${radius},${radius} 0 1,0 ${center.x - radius},${center.y} Z`;
  path.setAttribute('d', pathData);
  return { center: center, radius: radius }
}
